import { RootState } from '@/App/store';

export const selectLanguageSwitchEnabled = (state: RootState) => state.config.languageSwitchEnabled;
